// assets/collection-filters.js
(function () {
  'use strict';

  // ── Estado de filtros ──
  var state = {
    condition: 'all',
    series:    [],
    priceMin:  0,
    priceMax:  9999999,
    sort:      'manual',
    view:      'grid',
  };

  // ── Elementos ──
  var grid         = document.getElementById('products-grid');
  var noResults    = document.getElementById('no-results');
  var resultsCount = document.getElementById('results-count');
  var mobileCount  = document.getElementById('mobile-count');
  var bsCount      = document.getElementById('bs-count');
  var activeFiltersWrap  = document.getElementById('active-filters');
  var activeFiltersInner = document.getElementById('active-filters-inner');
  var clearBtn     = document.getElementById('sf-clear-btn');
  var nrClearBtn   = document.getElementById('no-results-clear');

  if (!grid) return;

  // ── Todas las tarjetas ──
  function getCards() {
    return Array.from(grid.querySelectorAll('.product-card, .product-list-row'));
  }

  // ── Aplicar filtros ──
  function applyFilters() {
    var cards = getCards();
    var visible = 0;

    cards.forEach(function (card) {
      var cond  = card.dataset.condition || '';
      var serie = card.dataset.serie     || '';
      var price = parseInt(card.dataset.price) || 0;

      var condOk  = state.condition === 'all' || cond === state.condition;
      var serieOk = state.series.length === 0 || state.series.indexOf(serie) !== -1;
      var priceOk = price >= state.priceMin && price <= state.priceMax;
      // Precio 0 = consultar — siempre mostrar
      if (price === 0) priceOk = true;

      var show = condOk && serieOk && priceOk;

      // Vista grid vs lista
      if (card.classList.contains('product-card')) {
        card.style.display = show && state.view === 'grid' ? '' : 'none';
        if (show && state.view === 'grid') visible++;
      } else {
        card.style.display = show && state.view === 'list' ? 'flex' : 'none';
        if (show && state.view === 'list') visible++;
      }
    });

    // Contar únicos (grid + list son el mismo producto)
    var uniqueVisible = 0;
    getCards().forEach(function(card) {
      if (card.classList.contains('product-card') && card.style.display !== 'none') uniqueVisible++;
      if (card.classList.contains('product-list-row') && card.style.display !== 'none') uniqueVisible++;
    });
    // Solo contar cards del tipo activo
    uniqueVisible = visible;

    // Actualizar contadores
    if (resultsCount) resultsCount.textContent = uniqueVisible;
    if (mobileCount)  mobileCount.textContent  = uniqueVisible;
    if (bsCount)      bsCount.textContent       = uniqueVisible;

    // Sin resultados
    if (noResults) noResults.style.display = uniqueVisible === 0 ? 'block' : 'none';

    // Botón limpiar
    var hasFilters = state.condition !== 'all' || state.series.length > 0 || state.priceMin > 0 || state.priceMax < 9999999;
    if (clearBtn) clearBtn.style.display = hasFilters ? 'block' : 'none';

    // Filtros activos pills
    renderActiveFilters();
    updateFilterBadge();
  }

  // ── Ordenar ──
  function applySort() {
    var cards = Array.from(grid.querySelectorAll('.product-card'));
    cards.sort(function (a, b) {
      var pa = parseInt(a.dataset.price) || 0;
      var pb = parseInt(b.dataset.price) || 0;
      var na = a.querySelector('.pc-name') ? a.querySelector('.pc-name').textContent : '';
      var nb = b.querySelector('.pc-name') ? b.querySelector('.pc-name').textContent : '';
      if (state.sort === 'price-asc')  return pa - pb;
      if (state.sort === 'price-desc') return pb - pa;
      if (state.sort === 'title-asc')  return na.localeCompare(nb);
      return 0;
    });

    // Reordenar también los list-rows
    var listRows = Array.from(grid.querySelectorAll('.product-list-row'));

    cards.forEach(function (card) { grid.appendChild(card); });
    listRows.forEach(function (row) { grid.appendChild(row); });

    applyFilters();
  }

  // ── Filtros activos ──
  function renderActiveFilters() {
    if (!activeFiltersInner) return;
    activeFiltersInner.innerHTML = '';
    var hasAny = false;

    if (state.condition !== 'all') {
      addActivePill(state.condition, function () {
        state.condition = 'all';
        syncSidebarCondition();
        syncBsCondition();
        applyFilters();
      });
      hasAny = true;
    }

    state.series.forEach(function (s) {
      var label = s.replace('serie-', 'iPhone ').replace('11-12', '11 y 12').replace('iphone-', 'iPhone ');
      addActivePill(label, function () {
        state.series = state.series.filter(function (x) { return x !== s; });
        syncSidebarSerie();
        syncBsSerie();
        applyFilters();
      });
      hasAny = true;
    });

    if (state.priceMax < 9999999 || state.priceMin > 0) {
      var priceLabel = state.priceMin === 0
        ? 'Hasta $' + (state.priceMax / 1000).toFixed(0) + 'k'
        : '$' + (state.priceMin / 1000).toFixed(0) + 'k – $' + (state.priceMax === 9999999 ? '+1M' : (state.priceMax / 1000).toFixed(0) + 'k');
      addActivePill(priceLabel, function () {
        state.priceMin = 0; state.priceMax = 9999999;
        syncSidebarPrice();
        syncBsPrice();
        applyFilters();
      });
      hasAny = true;
    }

    if (activeFiltersWrap) activeFiltersWrap.style.display = hasAny ? 'block' : 'none';
  }

  function addActivePill(label, onRemove) {
    var pill = document.createElement('span');
    pill.className = 'active-filter-pill';
    pill.innerHTML = label + ' <button class="active-filter-remove" aria-label="Quitar filtro">✕</button>';
    pill.querySelector('button').addEventListener('click', onRemove);
    activeFiltersInner.appendChild(pill);
  }

  function updateFilterBadge() {
    var badge = document.getElementById('filter-badge');
    var btn   = document.getElementById('mobile-filter-btn');
    var count = (state.condition !== 'all' ? 1 : 0)
              + state.series.length
              + (state.priceMax < 9999999 || state.priceMin > 0 ? 1 : 0);
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
    if (btn) btn.classList.toggle('has-filters', count > 0);
  }

  // ── SIDEBAR — Condición ──
  document.querySelectorAll('.sf-cond-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      state.condition = opt.dataset.value;
      syncSidebarCondition();
      syncBsCondition();
      applyFilters();
    });
  });

  function syncSidebarCondition() {
    document.querySelectorAll('.sf-cond-option').forEach(function (o) {
      o.classList.toggle('is-active', o.dataset.value === state.condition);
      var radio = o.querySelector('.sf-radio');
      if (radio) radio.dataset.active = o.dataset.value === state.condition ? 'true' : 'false';
    });
  }

  // ── SIDEBAR — Serie ──
  document.querySelectorAll('.sf-serie-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      var val = opt.dataset.value;
      var idx = state.series.indexOf(val);
      if (idx === -1) state.series.push(val);
      else state.series.splice(idx, 1);
      syncSidebarSerie();
      syncBsSerie();
      applyFilters();
    });
  });

  function syncSidebarSerie() {
    document.querySelectorAll('.sf-serie-option').forEach(function (o) {
      var active = state.series.indexOf(o.dataset.value) !== -1;
      o.classList.toggle('is-active', active);
    });
  }

  // ── SIDEBAR — Precio ──
  document.querySelectorAll('.sf-price-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      state.priceMin = parseInt(opt.dataset.min) || 0;
      state.priceMax = parseInt(opt.dataset.max) || 9999999;
      syncSidebarPrice();
      syncBsPrice();
      applyFilters();
    });
  });

  function syncSidebarPrice() {
    document.querySelectorAll('.sf-price-option').forEach(function (o) {
      var active = parseInt(o.dataset.min) === state.priceMin && parseInt(o.dataset.max) === state.priceMax;
      o.classList.toggle('is-active', active);
    });
  }

  // ── SIDEBAR — Sort ──
  var sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      state.sort = this.value;
      var mSort = document.getElementById('mobile-sort-select');
      if (mSort) mSort.value = this.value;
      applySort();
    });
  }

  // ── DESKTOP — Limpiar ──
  if (clearBtn) {
    clearBtn.addEventListener('click', clearAllFilters);
  }
  if (nrClearBtn) {
    nrClearBtn.addEventListener('click', clearAllFilters);
  }

  function clearAllFilters() {
    state.condition = 'all';
    state.series    = [];
    state.priceMin  = 0;
    state.priceMax  = 9999999;
    syncSidebarCondition();
    syncSidebarSerie();
    syncSidebarPrice();
    syncBsCondition();
    syncBsSerie();
    syncBsPrice();
    applyFilters();
  }

  // ── VISTA: Grid / Lista (solo desktop) ──
  var viewGrid = document.getElementById('view-grid');
  var viewList = document.getElementById('view-list');

  if (viewGrid) viewGrid.addEventListener('click', function () {
    state.view = 'grid';
    grid.classList.remove('is-list');
    viewGrid.classList.add('active');
    if (viewList) viewList.classList.remove('active');
    applyFilters();
  });

  if (viewList) viewList.addEventListener('click', function () {
    state.view = 'list';
    grid.classList.add('is-list');
    viewList.classList.add('active');
    if (viewGrid) viewGrid.classList.remove('active');
    applyFilters();
  });

  // ── MOBILE SORT ──
  var mobileSortSelect = document.getElementById('mobile-sort-select');
  if (mobileSortSelect) {
    mobileSortSelect.addEventListener('change', function () {
      state.sort = this.value;
      if (sortSelect) sortSelect.value = this.value;
      applySort();
    });
  }

  // ── BOTTOM SHEET ──
  var bsSheet   = document.getElementById('bs-sheet');
  var bsOverlay = document.getElementById('bs-overlay');
  var bsClose   = document.getElementById('bs-close');
  var bsClear   = document.getElementById('bs-clear');
  var bsApply   = document.getElementById('bs-apply');
  var mFilterBtn = document.getElementById('mobile-filter-btn');

  // Estado temporal del bottom sheet
  var bsTemp = {};

  function openBS() {
    // Clonar estado actual al temporal
    bsTemp = {
      condition: state.condition,
      series:    state.series.slice(),
      priceMin:  state.priceMin,
      priceMax:  state.priceMax,
    };
    if (bsSheet)  bsSheet.classList.add('is-open');
    if (bsOverlay) bsOverlay.classList.add('is-open');
    if (bsSheet)  bsSheet.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeBS() {
    if (bsSheet)  bsSheet.classList.remove('is-open');
    if (bsOverlay) bsOverlay.classList.remove('is-open');
    if (bsSheet)  bsSheet.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (mFilterBtn)  mFilterBtn.addEventListener('click', openBS);
  if (bsClose)    bsClose.addEventListener('click', closeBS);
  if (bsOverlay)  bsOverlay.addEventListener('click', closeBS);

  // Condición en BS
  document.querySelectorAll('.bs-cond-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      bsTemp.condition = pill.dataset.value;
      document.querySelectorAll('.bs-cond-pill').forEach(function (p) {
        p.classList.toggle('active', p.dataset.value === bsTemp.condition);
      });
      updateBsCount();
    });
  });

  // Serie en BS
  document.querySelectorAll('.bs-serie-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      var val = pill.dataset.value;
      var idx = bsTemp.series.indexOf(val);
      if (idx === -1) bsTemp.series.push(val);
      else bsTemp.series.splice(idx, 1);
      pill.classList.toggle('active', bsTemp.series.indexOf(val) !== -1);
      updateBsCount();
    });
  });

  // Precio en BS
  document.querySelectorAll('.bs-price-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      bsTemp.priceMin = parseInt(pill.dataset.min) || 0;
      bsTemp.priceMax = parseInt(pill.dataset.max) || 9999999;
      document.querySelectorAll('.bs-price-pill').forEach(function (p) {
        p.classList.toggle('active',
          parseInt(p.dataset.min) === bsTemp.priceMin &&
          parseInt(p.dataset.max) === bsTemp.priceMax
        );
      });
      updateBsCount();
    });
  });

  function updateBsCount() {
    var cards = getCards().filter(function (c) { return c.classList.contains('product-card'); });
    var count = cards.filter(function (card) {
      var cond  = card.dataset.condition || '';
      var serie = card.dataset.serie     || '';
      var price = parseInt(card.dataset.price) || 0;
      var condOk  = bsTemp.condition === 'all' || cond === bsTemp.condition;
      var serieOk = bsTemp.series.length === 0 || bsTemp.series.indexOf(serie) !== -1;
      var priceOk = price === 0 || (price >= bsTemp.priceMin && price <= bsTemp.priceMax);
      return condOk && serieOk && priceOk;
    }).length;
    if (bsCount) bsCount.textContent = count;
  }

  // Limpiar BS
  if (bsClear) {
    bsClear.addEventListener('click', function () {
      bsTemp = { condition: 'all', series: [], priceMin: 0, priceMax: 9999999 };
      syncBsCondition();
      syncBsSerie();
      syncBsPrice();
      updateBsCount();
    });
  }

  // Aplicar BS
  if (bsApply) {
    bsApply.addEventListener('click', function () {
      state.condition = bsTemp.condition;
      state.series    = bsTemp.series.slice();
      state.priceMin  = bsTemp.priceMin;
      state.priceMax  = bsTemp.priceMax;
      syncSidebarCondition();
      syncSidebarSerie();
      syncSidebarPrice();
      applyFilters();
      closeBS();
    });
  }

  function syncBsCondition() {
    var cond = bsTemp.condition !== undefined ? bsTemp.condition : state.condition;
    document.querySelectorAll('.bs-cond-pill').forEach(function (p) {
      p.classList.toggle('active', p.dataset.value === cond);
    });
  }

  function syncBsSerie() {
    var series = bsTemp.series !== undefined ? bsTemp.series : state.series;
    document.querySelectorAll('.bs-serie-pill').forEach(function (p) {
      p.classList.toggle('active', series.indexOf(p.dataset.value) !== -1);
    });
  }

  function syncBsPrice() {
    var pMin = bsTemp.priceMin !== undefined ? bsTemp.priceMin : state.priceMin;
    var pMax = bsTemp.priceMax !== undefined ? bsTemp.priceMax : state.priceMax;
    document.querySelectorAll('.bs-price-pill').forEach(function (p) {
      p.classList.toggle('active',
        parseInt(p.dataset.min) === pMin && parseInt(p.dataset.max) === pMax
      );
    });
  }

  // ── Inicializar estado desde colección activa o URL param ──
  var config = document.getElementById('collection-config');
  if (config) {
    var activeCond = config.dataset.activeCondition;
    if (activeCond && activeCond !== '') {
      state.condition = activeCond;
      syncSidebarCondition();
      syncBsCondition();
    }
  }

  // Leer ?condicion= de la URL (viene del mega menú)
  var urlParams = new URLSearchParams(window.location.search);
  var urlCond = urlParams.get('condicion');
  if (urlCond && urlCond !== '') {
    state.condition = urlCond;
    syncSidebarCondition();
    syncBsCondition();
  }

  // ── Init ──
  syncSidebarCondition();
  syncSidebarPrice();
  applyFilters();

})();